import { TID } from '@/constants/testIds';
import { INVESTMENTS } from '@/constants/content';
import { AlertCircle } from 'lucide-react';

export default function InvestmentSolutions() {
    return (
        <section id="investments" className="section-pad bg-navy text-white relative overflow-hidden">
            <div className="absolute inset-0 grain opacity-25" />
            <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-gold/10 blur-3xl" />

            <div className="container-wl relative">
                <div className="max-w-3xl">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="inline-block w-14 h-px bg-gold" />
                        <span className="text-[12px] uppercase tracking-widest2 text-gold font-semibold">
                            Investment Solutions
                        </span>
                    </div>
                    <h2 className="font-display-bold text-4xl lg:text-[56px] leading-[1.05] tracking-tight">
                        Investment Solutions <span className="italic text-gold">Tailored</span> to Your Goals.
                    </h2>
                    <p className="mt-5 text-white/70 text-[16.5px] leading-relaxed">
                        Independent guidance and investment facilitation across multiple asset classes —
                        chosen for fit, not commission.
                    </p>
                </div>

                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {INVESTMENTS.map((inv, i) => (
                        <div
                            key={inv.id}
                            data-testid={TID.investmentCard(inv.id)}
                            className="group bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.08] hover:border-gold/40 transition-all duration-500 rounded-xl"
                        >
                            <div className="flex items-baseline gap-3">
                                <span className="font-display-bold text-gold/70 text-2xl">
                                    0{i + 1}
                                </span>
                                <div className="h-px flex-1 bg-white/15 group-hover:bg-gold/60 transition-colors" />
                            </div>
                            <h3 className="font-display-bold text-white text-[20px] mt-5 leading-tight">
                                {inv.title}
                            </h3>
                            <p className="mt-3 text-[13.5px] text-white/65 leading-relaxed">
                                {inv.desc}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-14 bg-white/[0.04] border border-gold/30 p-6 lg:p-7 rounded-xl">
                    <div className="flex gap-4 items-start">
                        <AlertCircle className="w-5 h-5 text-gold shrink-0 mt-0.5" />
                        <div>
                            <p className="text-[12px] uppercase tracking-widest2 text-gold font-semibold mb-2">
                                Risk Disclaimer
                            </p>
                            <p className="text-[13.5px] text-white/75 leading-relaxed">
                                All investments are subject to market risks. Investment decisions should
                                be made after careful consideration of individual financial goals, risk
                                tolerance, and applicable regulatory requirements. Waylthlane Financials
                                offers advisory and investment facilitation services and does not
                                guarantee any returns or performance outcomes.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
